import Vue from "vue"
import VueRouter from "vue-router"

//push 
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

//replace
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(to) {
  return VueRouterReplace.call(this, to).catch(err => err)
}

Vue.use(VueRouter)

export default function (routes) {
  return new VueRouter({
    routes,
    mode: "hash"
  })
}
